export default __webpack_public_path__ + "images/6e25393b957fc12afa364be3d2174241-diners@2x.png";